export var QueueThreshold;
(function (QueueThreshold) {
    QueueThreshold["SLAPercentage"] = "sla_percentage";
    QueueThreshold["SLATimeLimit"] = "sla_time_limit";
    QueueThreshold["LongestWait"] = "longest_wait";
    QueueThreshold["AvailableAgents"] = "available_agents";
    QueueThreshold["WaitingConversations"] = "waiting_conversations";
})(QueueThreshold || (QueueThreshold = {}));
